export function initSummaryGroups(root = document) {
  root.querySelectorAll(".summary-groups").forEach((summary) => {
    if (summary.dataset.filtersInitialized === "1") return;
    summary.dataset.filtersInitialized = "1";

    const filters = Array.from(summary.querySelectorAll("[data-summary-filter]"));
    const tables = Array.from(summary.querySelectorAll(".summary-groups__table"));
    const highlightedClass = "summary-groups__cell--highlighted";
    const clearHighlights = [];

    const tableColumns = tables.map((table) => {
      const columns = new Map();
      table.querySelectorAll("[data-summary-column]").forEach((cell) => {
        const key = cell.dataset.summaryColumn;
        if (!columns.has(key)) columns.set(key, []);
        columns.get(key).push(cell);
      });

      let highlighted = [];
      let activeColumn = null;
      const clear = () => {
        highlighted.forEach((cell) => cell.classList.remove(highlightedClass));
        highlighted = [];
        activeColumn = null;
      };
      const highlight = (event) => {
        const cell = event.target.closest("[data-summary-column]");
        const column = cell && !cell.hidden ? cell.dataset.summaryColumn : null;
        if (column === activeColumn) return;
        clear();
        activeColumn = column;
        highlighted = columns.get(column) || [];
        highlighted.forEach((item) => item.classList.add(highlightedClass));
      };
      table.addEventListener("pointerover", highlight);
      table.addEventListener("pointerleave", clear);
      table.addEventListener("focusin", highlight);
      table.addEventListener("focusout", clear);
      clearHighlights.push(clear);
      return columns;
    });

    const classHeaders = Array.from(tables[0]?.querySelectorAll("thead [data-summary-column][data-summary-facility]") || []);
    const groupHeaders = Array.from(summary.querySelectorAll('th[scope="colgroup"]'));
    const pairKey = (element) => JSON.stringify([element.dataset.summaryFacility, element.dataset.summaryCycle]);
    const update = () => {
      const selected = new Set(filters.filter((filter) => filter.checked).map(pairKey));
      const visible = (header) => selected.has(pairKey(header));
      let visibleCount = 0;
      clearHighlights.forEach((clear) => clear());
      classHeaders.forEach((header) => {
        const show = visible(header);
        if (show) visibleCount++;
        tableColumns.forEach((columns) => {
          (columns.get(header.dataset.summaryColumn) || []).forEach((cell) => { cell.hidden = !show; });
        });
      });
      // Each merged header covers one facility/cycle pair, so its entire span toggles together.
      groupHeaders.forEach((header) => { header.hidden = !visible(header); });
      const status = summary.querySelector("[data-summary-status]");
      if (status) status.textContent = `Widoczne oddziały: ${visibleCount} / ${classHeaders.length}`;
    };

    if (filters.length > 0) {
      summary.addEventListener("change", (event) => {
        if (event.target.matches("[data-summary-filter]")) update();
      });
      summary.querySelector("[data-summary-reset]")?.addEventListener("click", () => {
        filters.forEach((filter) => { filter.checked = true; });
        update();
      });
      update();
      summary.querySelector(".summary-groups__filters").hidden = false;
    }
  });
}
